import { Suspense, React } from "react";
import BusinessSettingsContainer from "../../Containers/BusinessSettings";
import AppLoader from "../../Components/AppLoader";

const index = () => {
  return <Suspense fallback={<AppLoader />}>
           <BusinessSettingsContainer />
        </Suspense>;
};

export default index;
